<!--
 * @Author: LiGang
 * @Date: 2024-11-08 10:30:08
 * @LastEditors: LGLG 2549576889@qq.com
 * @LastEditTime: 2025-05-08 17:52:23
 * @FilePath: /parkH5New/src/views/escape/EscapeIn.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<!-- 入场通道缴费 -->
<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="入场支付"
      right-text=""
    />
    <div class="mainBox">
      <div class="container">
        <div class="row1">
          <div class="number">{{ vh_p_number }}</div>
          <div
            class="normal">
            {{ plateNumFormatterCate(cateID,vh_p_number) }}
          </div>
        </div>
        <div class="row4 row5">
          <span class="time-tip">入场时间:</span>
          <span class="in-time">{{ in_time | filterTime }}</span>
        </div>
        <div class="row4 row5">
          <span class="time-tip">停车时长:</span>
          <span class="in-time"
            >{{parked_time}}</span
          >
        </div>

        <div class="row4 row5">
          <span class="time-tip" style="display:flex;">
            <van-checkbox v-if="escapeConfig.check_in_mode&&escapeConfig.check_in_mode === 1" shape="square" v-model="escapeChecked" @change="escapeCheckedChange()"></van-checkbox>欠费金额:</span>
          <span class="in-time" @click="openEscapeOrder()">￥{{ (escape_pay / 100).toFixed(2) }}
            <span style="margin-left: 4px;">（{{ count_zero }}笔）</span>
            <van-icon size="0.16rem" color="#333" name="arrow" />
          </span>
        </div>
        <div
          class="commentBox"
          v-if="comment !== '' && comment !== null && comment !== undefined"
        >
          <span class="comment-time-tip">备注:</span>
          <span class="comment-in-time">{{ comment }} </span>
        </div>
        <div class="row4 row6">
          <span class="time-tip">需缴费:</span>
          <span class="price">￥{{ (actually_paid / 100).toFixed(2) }}</span>
        </div>
        <div class="button-row-pay">
          <van-button
            :disabled="
              !isTypeReady ||
              !isVueReady ||
              isPress ||
              (actually_paid > 0 && !code)
            "
            type="info"
            size="large"
            @click="confirmPay"
            >确认支付</van-button
          >
        </div>
      </div>
      <div class="banner" v-if="adConfigReady && !isCloseAD">
        <adver position="EXIT_ORDER_BANNER"></adver>
      </div>
      <div v-if="!isTypeReady" class="mask_layout" @click.stop></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as mqtt from '../../api/mqtt/wsconnect.js'
import CarKeyboard from '../../components/CarKeyboard.vue'
import { Toast } from 'vant'
import { mapState, mapGetters } from 'vuex'
import * as constant from '../../api/constant'
import * as common from '../../api/common'
import * as util from '../../api/util'
import { getPayTypeBySid } from '../../api/paycloudService'
import * as api from '../../api/api'
import * as parkService from '../../api/parkService'
import * as paycloudService from '../../api/paycloudService'
import BindPhone from '../../components/BindPhone.vue'
import NotAuthOrPhone from '../../components/NotAuthOrPhone.vue'
import adver from '../../components/Adver.vue'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    adver
  },
  data () {
    // 这里存放数据
    return {
      sid: '',
      channel_path: '',
      code: '',
      payType: '',
      appidLocal: '',
      methodName: 'vh_fee_order_escape.get_escape_info',
      local_info: {
      },
      vh_p_number: '',
      parked_time: '',
      in_time: '',
      end_time: '',
      actually_paid: '',
      escape_pay: '',
      //   payablefee: 5,
      comment: '',

      isVueReady: false,
      isTypeReady: false,
      isPress: false,

      tempBack: {
        expireMillSeconds: 240 * 1000,
        timeout: null,
        timestamp: 0
      },

      sign: '',
      parkName: '车场',
      isEmqxConnect: false,
      escapeOrder: 0,
      isCloseAD: false,
      adConfigReady: false,
      lastPaidTotal: '', // 已支付金额
      lastDiscoutPure: '', // 已优惠金额
      cateID: '', // 车辆类别
      escapeConfig: {},
      escapeChecked: true,
      escapeInfoList: [],
      escapeInfo: {},
      escape_fee_order_sn: '',
      time_start: '',
      time_end: '',
      count_zero: 0, // 欠费笔数
      grossPrice: 0, // 应收金额
      bSupplementAll: false, // 是否追缴全部
      total: 0, // 所有欠费订单数目
      pageSize: 0, // 返回的每页查询条数

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    escapeCheckedChange () {
      console.log('入口是否勾选逃费订单', this.escapeChecked)

      if (this.escapeChecked) {
        this.actually_paid = this.escapeInfo.fee_value
      } else {
        this.actually_paid = 0
      }
    },
    openEscapeOrder () {
      let needPageQryFlag = false // true则追缴全部 需要传递分页参数；false则只传递当前欠费订单即可
      if (this.bSupplementAll) {
        if (this.total <= this.pageSize) {
        // 说明全部欠费数目小于每页查询条数，则不需要传递分页参数
          needPageQryFlag = false
        } else {
          needPageQryFlag = true
        }
      } else {
        needPageQryFlag = false
      }
      this.$router.push({
        path: '/vh_fee_order_escape_detail',
        query: {
          channel_path: this.$route.query.channel_path,
          sid: this.$route.query.sid,
          parkName: this.parkName,
          escData: JSON.stringify(this.escapeInfoList),
          direction: 1,
          needPageQryFlag: needPageQryFlag,
          vh_p_number: this.vh_p_number,
          time_start: this.time_start,
          time_end: this.time_end,
        //   localInfo: JSON.stringify(this.localInfo)
        }
      })
    },
    async escapeInit () {
      // 查询入场的逃费追缴配置
      const escapeConfig = await this.getEscapeConfig()
      this.escapeConfig = escapeConfig
      console.log('逃费配置', this.escapeConfig)
      // 如果入场时 配置为未开启，是否需要提示当前车道的车辆信息

      // 如果配置没有开启
      // 如果配置为提示模式
      // 如果配置为严格模式

      // 获取当前车场支付平台
      this.getPayType()
      // TODO 获取code
      //   if (!this.code) {
      //     this.getAllCode()
      //   }

      // 查询入口通道费用
      this.queryChannelPrice()
    },
    // 获取逃费追缴配置
    async getEscapeConfig () {
      try {
        const { IotService } = await import('../../api/iotService')
        const data = await IotService.getEscapeConfig(
          this.sid || this.$route.query.sid,
          'v2'
        )

        if (data.code === 10000) {
          console.log('逃费追缴配置', data)
          //   TODO 如果没有任何配置 进行提示
          return data.info || {}
        //   this.escapeConfig = data.info
        } else {
          Toast.fail('查询出错')
        }
      } catch (e) {
        this.$toast('查询异常')
      }
    },
    // 根据通道号查询是否存在欠费信息
    async queryChannelPrice () {
      console.log('queryChannelPrice')
      Toast.loading({
        forbidClick: true,
        message: '请稍候...'
      })
      try {
        const { data } = await axios({
        //   url: common.cloudPayUrl + '/pub/' + api.urlList.pay.bill.park_plate.get_self_info,
          // url: 'http://121.37.172.247:7997/api/no_sign/request.pls_req',
          url: common.reqMqCloudUrl + '/api/no_sign/request.pls_req',
          method: 'POST',
          data: {
            sid: this.sid || this.$route.query.sid,
            method: this.methodName,
            // openid: this.openID,
            params: {
              channel_path: Number(this.channel_path) || Number(this.$route.query.channel_path),
              sid: this.sid || this.$route.query.sid,
              page_size: 10,
              page_no: 1
            }
          },
          header: {
            'content-type': 'application/json' // 默认值
          }
        })
        console.log('接收到入口逃费信息data', data)
        // todo data.data就是后续要传的 local_info
        if (data.code === 10000 && data.data) {
          console.log('接收到入口缴费Info', data.data)
          // TODO 如果data.data 是纯文本 则直接输入该提示 说明在通道内没有查询到
          if (typeof data.data !== 'object' || data.data === null || Array.isArray(data.data)) {
            if (typeof data.data === 'string') {
              Toast(data.data)
            } else {
              Toast('数据格式异常')
            }
            this.closePage()
            return
          }

          this.sign = data.data.sign
          this.local_info = data.data
          this.$toast.clear()
          if (data.data.vh_p_number === '') {
            Toast('未找到收费车辆信息，请退出重新扫码，稍后自动关闭', data.msg)
            this.closePage()
            return
          }
          console.log('逃费配置展示', this.escapeConfig)
          // 如果配置没有开启或者当前车辆无欠费信息
          if (this.escapeConfig.boot === 0 || data.data.escInfo.list.length === 0) {
            Toast('欢迎入场，即将为您开闸')
            // TODO 通知进行开闸操作
            this.closePage()
            return
          }
          if (this.escapeConfig.boot === 1 && this.escapeConfig.check_in_mode === 0) {
            Toast('欢迎入场，即将为您开闸')
            // TODO 通知进行开闸操作
            this.closePage()
            return
          }
          if (this.escapeConfig.boot === 1 && this.escapeConfig.check_in_mode === 1) {
            Toast('欢迎入场，即将为您开闸')
            // TODO 通知进行开闸操作
            this.closePage()
            return
          }
          if (data.data.escInfo.list && data.data.escInfo.list.length === 0) {
            // 此时没有欠费订单 自动开闸
            Toast('欢迎入场，即将为您开闸')
            // TODO 通知进行开闸操作
            this.closePage()
            return
          }
          const info = data.data
          console.log('+++', info)
          this.escapeInfoList = data.data.escInfo.list
          this.escapeInfo = info
          this.vh_p_number = info.vh_p_number
          this.cateID = info.vh_cate_id
          this.sign = info.sign
          //   this.comment = info.state_ab_comment
          this.comment = info.cancel_comment
          this.parked_time = util.countParkTime(info.start_time, info.end_time)
          //   const localInfo = data.data.local_info
          this.in_time = info.start_time
          this.end_time = info.end_time

          const total = data.data.total
          this.total = total
          const grossPrice = data.data.gross_price || 0
          const sumDetail = data.data.escInfo.sum_detail
          const bSupplementAll = data.data.escInfo.bSupplementAll
          this.pageSize = data.data.escInfo.page_size
          this.time_start = data.data.escInfo.time_start
          this.time_end = data.data.escInfo.time_end
          this.bSupplementAll = bSupplementAll
          if (bSupplementAll) {
            // 追缴全部
            // 获取本次欠费笔数
            if (sumDetail && typeof sumDetail.count_zero !== 'undefined') {
              this.count_zero = Number(sumDetail.count_zero) || 0
            }
            // 获取本次欠费金额
            if (sumDetail && typeof sumDetail.total_fee_zero !== 'undefined') {
              this.escape_pay = Number(sumDetail.total_fee_zero) || 0
              this.actually_paid = Number(sumDetail.total_fee_zero)
            }
          } else {
            // 追缴最近一笔
            // 直接取值list[0]
            if (this.escapeInfoList && this.escapeInfoList.length > 0) {
              this.escape_pay = this.escapeInfoList[0].fee_value
              this.actually_paid = this.escapeInfoList[0].fee_value
              this.count_zero = 1
            }
          }

          if (this.actually_paid > 0) {
            // TODO 打包时放开注释
            this.getAllCode()
          } else {
            this.$toast('收费 0 元')
            this.closePage()
          }
        } else {
          this.$toast.clear()
          Toast('获取车辆逃费信息失败：' + data.msg || '查询出错，请退出重新扫码')
          this.closePage()
        }
      } catch (e) {
        this.$toast.clear()
        Toast(e || '查询异常，请退出重新扫码')
        this.closePage()
      }
    },
    confirmPay: async function () {
      if (new Date().getTime() - this.tempBack.timestamp > this.tempBack.expireMillSeconds) {
        this.clearBackTimeout()
        return this.expireGoBack()
      }
      this.isPress = true
      if (parseFloat(this.actually_paid) <= 0) {
        this.$toast('收费 0 元')
        // return
      }
      const that = this
      try {
        // 除了支付为0元，所有支付都要获取code
        if (that.actually_paid > 0) {
          if (!this.code) {
            this.getAllCode()
            return
          }
        }

        if (!this.isVueReady) {
          return this.$toast('努力加载中.')
        } else if (!this.isTypeReady) {
          if (common.getUserAgent() === 'wx') {
            return this.$toast('微信努力加载中.')
          } else {
            return this.$toast('支付宝努力加载中.')
          }
        }

        doPay()
      } catch (e) {
        console.log(e)
        this.$toast.fail('请求失败')
      }
      function doPay () {
        that.$toast.loading({
          mask: true,
          message: '请稍候...',
          duration: 5000
        })
        const obj = {
          sid: that.sid,
          gross_price: parseFloat(that.actually_paid),
          actually_paid: parseFloat(that.actually_paid),
          // req_order_sn: that.req_order_sn,
          sign: that.sign,
          code: that.code || 'invalid',
          plate_number: that.vh_p_number,
          subject: (that.parkName ? that.parkName + ' ' : '') + that.vh_p_number + '入口追缴收费',
          start_time: that.in_time,
          end_time: that.end_time,
          local_info: that.local_info,
          is_xcx: false
        }
        console.log('doPay-参数', obj)
        parkService.getPayargs(obj, null, Number(that.payType), Number(that.channel_path), common.getUserAgent() === 'wx')
          .then(payargs => {
            // return

            that.$toast.clear()

            if (parseFloat(that.actually_paid) <= 0) {
              that.isPress = true
              that.$toast({
                type: 'success',
                message: '支付0元',
                duration: 3000,
                forbidClick: true
              })
              setTimeout(function () {
                if (common.getUserAgent() === 'wx') {
                  // eslint-disable-next-line no-undef
                  WeixinJSBridge.call('closeWindow')
                } else if (common.getUserAgent() === 'zfb') {
                  // eslint-disable-next-line no-undef
                  ap.popWindow()
                }
              }, 3000)
            } else {
              console.log('is wx1')

              that.isPress = false
              if (common.getUserAgent() === 'wx') {
                console.log('is wx2')
                that.wxReadyToPay(payargs)
              } else if (common.getUserAgent() === 'zfb') {
                that.do_zfb_pay(payargs)
              }
            }
          })
          .catch(e => {
            that.$toast.clear()
            that.isPress = false
            if (parseFloat(that.actually_paid) > 0) {
              console.log(e)
              that.$dialog.alert({
                title: `错误码：${e.code || '未知'}`,
                message: e.message || '支付失败'
              }).then(() => {
                that.onClickLeft()
              })
            } else that.$toast.clear()
          })
      }
    },
    getAllCode () {
      // console.log('getAllCode', this.code, this.appid)
      // console.log('getAllCode', !this.code)
      if (this.code) {
        return
      }
      if (common.getUserAgent() === 'wx') {
        // console.log('wx getcode')
        this.getAppId().then(appid => {
          // window.location.href = common.getCodeObtainUrl(window.location, appid, true)
          // console.log('window.location.href', window.location.href)
          console.log('当前页面的Query参数', this.$route.query)

          const rawQuery = this.$route.query
          const { plate_number } = rawQuery
          // 存储所有参数，以 plate_number 为 key
          localStorage.setItem(`urlQueryInfo:${this.vh_p_number}`, JSON.stringify(rawQuery))

          const target = new URL(window.location.origin + '/#/fee_in_escape')
          target.searchParams.set('plate_number', this.vh_p_number)


          const toUrl = common.getCodeObtainUrl(target, appid, true)
          // const toUrl2 = common.getCodeObtainUrl(window.location, appid, true)

          console.log('拼接后的短跳转链接', toUrl)
          const savedQuery = JSON.parse(localStorage.getItem(`urlQueryInfo:${this.vh_p_number}`) || '{}')
          console.log('savedQuery', savedQuery)

          window.location.href = toUrl
        }).catch(e => {
          this.$toast('获取appid失败', e)
        })
      } else if (common.getUserAgent() === 'zfb') {
        if (!this.code) {
          this.getZFBAppId().then(appid => {
            window.location.href = common.getCodeObtainUrl(window.location, appid, false)
          }).catch(e => {
            this.$toast('获取appid失败', e)
          })
        }
      }
      // console.log('22222222222222')
    },
    async getAppId () {
      const appId = await paycloudService.getAppIdWx(this.sid)
      if (appId) {
        this.appidLocal = appId
        return this.appidLocal
      } else {
        return Promise.reject(new Error('获取AppID失败'))
      }
    },
    async getZFBAppId () {
      const appIdData = await paycloudService.getAppIdZfb(this.sid)
      if (appIdData) {
        this.appidLocal = appIdData.auth_app_id
        this.$store.commit(constant.keyAppIDVuex, appIdData.app_id)
        return this.appidLocal
      } else {
        return Promise.reject(new Error('获取支付宝AppID失败'))
      }
    },
    async getPayType () {
      const thePayType = await getPayTypeBySid(this.$route.query.sid)
      console.log('thePayType: ', thePayType)
      this.payType = thePayType
    //   this.$store.commit(constant.keyPayTypeVuex, thePayType)
    },
    closePage () {
      setTimeout(() => {
        this.doCloseAll()
      }, 1000)
    },
    doCloseAll () {
      if (common.getUserAgent() === 'wx') {
        this.closeWindowWX()
      } else if (common.getUserAgent() === 'zfb') {
        this.closeWindowZfb()
      }
    },
    closeWindowWX () {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', close(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', close())
          document.attachEvent('onWeixinJSBridgeReady', close())
        }
      } else {
        close()
      }

      function close () {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.call('closeWindow')
      }
    },
    closeWindowZfb () {
      if (window.AlipayJSBridge) {
        close()
      } else {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', close(), false)
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', close())
        }
      }

      function close () {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('closeWebview')
      }
    },
    plateNumFormatterCate (val, num) {
      let name = ''
      if (/^N.*/.test(num)) {
        name = '无牌车'
      } else if (Number(val) === 2) {
        name = '临时车'
      } else {
        name = '固定车'
      }
      return name
    },
    WX_Bridge_ready (cb) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', cb(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', cb())
          document.attachEvent('onWeixinJSBridgeReady', cb())
        }
      } else {
        cb()
      }
    },
    getTempBackTimeout () {
      const ms = this.tempBack.expireMillSeconds
      if (!this.tempBack.timestamp) this.tempBack.timestamp = new Date().getTime()
      // console.log('tempBack.timestamp', this.tempBack.timestamp)
      this.tempBack.timeout = setTimeout(() => {
        this.expireGoBack()
        this.clearBackTimeout()
      }, ms)
    },
    clearBackTimeout () {
      clearTimeout(this.tempBack.timeout)
      this.tempBack.timeout = null
    },
    expireGoBack () {
      this.tempBack.timestamp = 0
      this.$dialog.alert({
        // showCancelButton: true,
        title: '支付超时',
        message: '点击“确认”后重新付款'
      }).then(() => {
        this.doCloseAll()
      })
    },
    // 获取关闭广告配置
    queryADConfig () {
      const flag = util.judgeADClose({}, 2, 2)
      this.isCloseAD = flag
      this.adConfigReady = true
    },
    async query_customer_by_sid () {
      const parkInfo = await parkService.queryCustomerBySid(this.sid || this.$route.query.sid)
      if (parkInfo) {
        this.parkName = parkInfo.parkname
      }
    },
    ZFBReady (callback) {
      if (window.AlipayJSBridge) {
        callback && callback()
      } else {
        if (document.addEventListener) {
          document.addEventListener('AlipayJSBridgeReady', callback, false)
        } else if (document.attachEvent) {
          document.attachEvent('AlipayJSBridgeReady', callback)
        }
      }
    },
    do_zfb_pay (payargs) {
      const that = this

      this.ZFBReady(function () {
        const payType = Number(that.payType)
        if (payType === common.payType.zfb || payType === common.payType.zero) { // 支付宝直联
          // eslint-disable-next-line no-undef
          ap.tradePay({
            tradeNO: payargs.tradeNo
          }, function (res) {
            if (res && (res.resultCode === '9000' || res.resultCode === 9000)) {
              that.isPress = true
              that.doCloseAll()
              if (common.adverType === '2') {
                // eslint-disable-next-line no-undef
                AlipayJSBridge.call('pushWindow', {
                  url: 'https://bo111.yuntingiot.com/api/ac/477786592149311488',
                  param: {
                    backBehavior: 'pop',
                    closeCurrentWindow: true
                  }
                })
              }
            } else {
              that.$dialog.alert({
                title: '支付失败'
              }).then(() => {
                // ToDo 暂时将支付宝失败时关闭应用处理，后续优化
                that.doCloseAll()
              })
            }
          })
        } else if (payType === common.payType.bjyz_zfb) { // 支付宝云纵间联
          const pars = {
            start_time: that.in_time,
            actually_paid: that.actually_paid,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.vh_p_number,
            in_channel_pay: true
          }
          console.log('zfb 云纵', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          that.isPress = true
          window.location.replace(payargs.trade_url)
        } else if (payType === common.payType.pp_zfb) { // 支付宝PP间联
          const pars = {
            start_time: that.in_time,
            actually_paid: that.actually_paid,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.vh_p_number,
            in_channel_pay: true
          }
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          window.location.replace(payargs.pay_url)
        } else if (payType === common.payType.icbc_zfb) { // 工商支付宝间联
          const pars = {
            start_time: that.start_time,
            hour: that.hour,
            min: that.min,
            seconds: that.seconds,
            actually_paid: that.actually_paid,
            couponPrice1: that.couponPrice1,
            invoice_url: payargs.invoice_url,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.plate_number
          }
          console.log('工商 zfb', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)
          window.location.replace(payargs.pay_url)
        } else if (payType === common.payType.abc_zfb) { // 支付宝农行间联
          if (payargs.tradeNo) {
            // eslint-disable-next-line no-undef
            ap.tradePay({
              tradeNO: payargs.tradeNo
            }, function (res) {
              if (res && (res.resultCode === '9000' || res.resultCode === 9000)) {
                that.isPress = true
                that.doCloseAll()
                if (common.adverType === '2') {
                // eslint-disable-next-line no-undef
                  AlipayJSBridge.call('pushWindow', {
                    url: 'https://bo111.yuntingiot.com/api/ac/477786592149311488',
                    param: {
                      backBehavior: 'pop',
                      closeCurrentWindow: true
                    }
                  })
                }
              } else {
                that.$dialog.alert({
                  title: '支付失败'
                }).then(() => {
                // ToDo 暂时将支付宝失败时关闭应用处理，后续优化
                // that.onClickLeft()
                  that.doCloseAll()
                })
              }
            })
          } else {
            const pars = {
              start_time: that.in_time,
              actually_paid: that.actually_paid,
              sid: that.sid,
              parkName: that.parkName,
              plateNumber: that.vh_p_number,
              in_channel_pay: true
            }
            console.log('zfb 农行', pars)
            that.$store.commit(constant.keyAdverInfoVuex, pars)

            window.location.replace(payargs.pay_url)
          }
        } else if (payType === common.payType.lanzhoubank_zfb) { // 支付宝兰州银行间联
          const pars = {
            start_time: that.in_time,
            actually_paid: that.actually_paid,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.vh_p_number,
            in_channel_pay: true
          }
          that.$store.commit(constant.keyAdverInfoVuex, pars)

          window.location.replace(payargs.billQRCode)
        } else if (payType === common.payType.ningbobank_zfb) { // 支付宝宁波银行间联
          const pars = {
            start_time: that.in_time,
            actually_paid: that.actually_paid,
            sid: that.sid,
            parkName: that.parkName,
            plateNumber: that.vh_p_number,
            in_channel_pay: true
          }
          console.log('zfb 宁波银行', pars)
          that.$store.commit(constant.keyAdverInfoVuex, pars)

          window.location.replace(payargs.pay_url)
        }
      })
    },
    onBridgeReady (payargs) {
      var that = this

      const payType = Number(this.payType)
      if (payType === common.payType.wx || payType === common.payType.zero) { // 微信直联
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: payargs.appId != null ? payargs.appId : that.appid, // 公众号名称，由商户传入
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace('https://pa03.yuntingiot.com/api/ac/477786592149311488')
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.$dialog.alert({
                // showCancelButton: true,
                title: '支付失败'
              }).then(() => {
                that.doCloseAll()
              })
            }
          })
      } else if (payType === common.payType.bjyz) { // 微信云纵间联
        const pars = {
          start_time: this.in_time,
          actually_paid: this.actually_paid,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.vh_p_number,
          in_channel_pay: true
        }
        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.trade_url)
        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.pp) { // 微信PP间联
        //   TODO pp支付
        console.log('pppay', payType)
        console.log('pppay', common.payType.pp)
        const pars = {
          start_time: this.in_time,
          actually_paid: this.actually_paid,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.vh_p_number,
          in_channel_pay: true

        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.icbc) { // 工商微信间联
        const pars = {
          start_time: this.start_time,
          hour: this.hour,
          min: this.min,
          seconds: this.seconds,
          actually_paid: this.actually_paid,
          couponPrice1: this.couponPrice1,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.plate_number
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.abc) { // 微信农行间联
        const pars = {
          start_time: this.in_time,
          actually_paid: this.actually_paid,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.vh_p_number,
          in_channel_pay: true
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true

        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: payargs.appId != null ? payargs.appId : that.appid, // 公众号名称，由商户传入
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace('https://pa03.yuntingiot.com/api/ac/477786592149311488')
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.$dialog.alert({
                // showCancelButton: true,
                title: '支付失败'
              }).then(() => {
                that.doCloseAll()
              })
            }
          })
      } else if (payType === common.payType.lanzhoubank) { // 兰州银行微信
        const pars = {
          start_time: this.in_time,
          actually_paid: this.actually_paid,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.vh_p_number,
          in_channel_pay: true
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.billQRCode)
      } else if (payType === common.payType.ningbobank) { // 宁波银行微信
        const pars = {
          start_time: this.in_time,
          actually_paid: this.actually_paid,
          sid: this.sid,
          parkName: this.parkName,
          plateNumber: this.vh_p_number,
          in_channel_pay: true
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.pay_url)
      }
    },
    wxReadyToPay (payargs) {
      var that = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady(payargs), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady(payargs))
          document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady(payargs))
        }
      } else {
        that.onBridgeReady(payargs)
      }
    }

  },
  filters: {
    filterVH (num) {
      const reg = /^N.*/
      if (reg.test(num)) {

      }
    },
    filterClass (num) {
      const reg = /^N.*/
      if (num.length < 8) {

      }
      if (reg.test(num)) {

      }
    },
    filterTime (time) {
      console.log('入场时间time 格式化', time)
      try {
        if (time) {
          return common.fmtDate(time, 'yyyy-MM-dd hh:mm:ss')
        } else {
          return '无入场时间'
        }
      } catch (e) {
        return '不支持的时间格式'
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    if (common.getUserAgent() === 'wx') {
      this.code = this.$route.query.code
    } else if (common.getUserAgent() === 'zfb') {
      this.code = this.$route.query.auth_code
    }
    this.query_customer_by_sid()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('准备逃费追缴-入口')
    console.log('mounted query', this.$route.query)
    Toast.loading({
      forbidClick: true,
      message: '请稍候...'
    })
    this.queryADConfig()

    if (!this.$route.query.sid && !this.$route.query.channel_path) {
      this.$toast.clear()

      this.$dialog.alert({
        title: '提示',
        message: 'URL地址失效'
      }).then(() => {
        this.doCloseAll()
      })
    }
    this.sid = this.$route.query.sid
    this.channel_path = this.$route.query.channel_path

    this.isVueReady = true

    const that = this

    if (common.getUserAgent() === 'wx') {
      this.WX_Bridge_ready(() => {
        setButtonClertload()
      })
    } else if (common.getUserAgent() === 'zfb') {
      this.ZFBReady(() => {
        setButtonClertload()
      })
    }

    function setButtonClertload () {
      that.$nextTick(() => {
        that.isTypeReady = true
        console.log('isTypeReady', that.isTypeReady)
      })
    }
    this.escapeInit()

    this.getTempBackTimeout()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    localStorage.removeItem(`urlQueryInfo:${this.vh_p_number}`)

  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
.mainBox {
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.container {
  margin-top: 0.22rem;
  padding: 0 0.3rem;
}

.mask_layout {
//   z-index: 9999;
  background-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.row1 {
  display: flex;
  align-items: center;
  justify-content: left;
}

.row1 .number {
  font-size: 0.22rem;
  font-weight: bold;
  margin-right: 0.06rem;
}

.row1 .normal {
  font-size: 0.16rem;
  padding: 0.01rem 0.04rem;
  background: #f4f4f4;
  border-radius: 0.12rem;
}

.row1 .special {
  font-size: 0.16rem;
  padding: 0.01rem 0.04rem;
  color: #7eab4c;
  background: #e9f9dc;
  border-radius: 0.12rem;
}

.row2 {
  margin-top: 0.36rem;
  text-align: center;
  font-size: 0.16rem;
}

.row3 {
  margin-top: 0.12rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.row3 .code {
  font-size: 0.28rem;
  color: #333;
  font-weight: bold;
  margin-right: 0.06rem;
}

.row3 .number {
  font-size: 0.42rem;
  color: #333;
  font-weight: bold;
}

.row4 {
  margin-top: 0.24rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 0.01rem solid #ededed;
  border-bottom: 0.01rem solid #ededed;
}

.row4 .time-tip {
  color: #999;
  font-size: 0.14rem;
}

.row4 .in-time {
  color: #333;
  font-size: 0.16rem;
}

.row5,
.row6 {
  margin-top: 0;
  border-top: none;
}

.row5 > .couponPrice {
  display: flex;
  align-items: center;
  font-size: 0.14rem;
  font-weight: bold;
  color: rgba(238, 38, 10, 1);
}
.couponPrice img {
}

.row6 > .time-tip {
  font-size: 0.14rem;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.row6 {
  border-bottom: none;
  margin-top: 23px;
}

.row6 > .price {
  font-size: 0.24rem;
  font-weight: bold;
  color: rgba(255, 62, 0, 1);
}

.button-row-pay {
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  font-size: 0.1rem;
}

.dialogBox {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70%;
  background: #fff;
  padding: 0.2rem 0.12rem 0;
  box-sizing: border-box;
  z-index: 9000;
}

.dialogHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.16rem;
  margin-bottom: 0.18rem;
  font-weight: bold;
}

.dialogHead > img {
  width: 0.2rem;
  height: 0.2rem;
}

.listBox {
  height: 72%;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
}

.listBox::-webkit-scrollbar {
  display: none;
}

.dialogList {
  display: flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  height: 0.94rem;
  margin-bottom: 0.1rem;
}

.dialogList > div:first-child {
  color: #ee260a;
  font-size: 0.18rem;
  width: 33%;
  text-align: center;
}

.dialogList > div:first-child span {
  font-size: 0.32rem;
}

.dialogList > div:nth-child(2) {
  height: 0.6rem;
  border-left: 1px solid rgba(228, 223, 223, 1);
  margin-right: 0.18rem;
}

.dialogList > div:nth-child(3) {
  margin-right: 0.1rem;
}

.dialogList > div:nth-child(3) > div:first-child {
  font-size: 0.14rem;
  color: #333333;
  margin-bottom: 0.04rem;
  font-weight: bold;
  margin-left: .2667rem;
}

.dialogList > div:nth-child(3) > div {
  /* margin-bottom: 0.06rem; */
  margin-bottom: 0.025rem;
  color: #909090;
  text-align: left;
}
.dialogList .showBizName{
  font-size: 0.12rem;
  color: #333333;
  margin-left: 5px;
}

.dialogBTN {
  width: 3.17rem;
  height: 0.5rem;
  background: rgba(71, 151, 234, 1);
  border-radius: 2px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
  margin: 0.18rem auto 0;
}

/* add */
.commentBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.01rem solid #ededed;
  padding: 0.15rem 0;
  /* border-bottom: none; */
  /* height: 1rem ; */
  /* height: 100%; */
  /* line-height: .5rem; */
}
.comment-time-tip {
  color: #999;
  font-size: 0.14rem;
}
.comment-in-time {
  max-width: 250px;
  text-align: right;
  line-height: 0.2rem;
  font-size: 0.14rem !important;
}
</style>
